<template>
  <el-button class="data-refresh-menu grid-menu-item"
             type="text"
             :class="{'is-refresh': refreshing}"
             @click="handleClick">
    <i v-if="refreshing"
       class="theme-text iconfont icon-shuaxin"></i>
    <i v-else
       class="iconfont icon-shuaxin"></i>
  </el-button>
</template>

<script>
export default {
  name: 'DataRefreshMenu',
  props: {
    refreshing: Boolean
  },
  methods: {
    handleClick () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
  .data-refresh-menu {
    &.is-refresh {
      i {
        animation: refreshing 1s linear 0s infinite;
        transform-origin: center center;
      }
    }
    @keyframes refreshing {
      0%{transform:rotate(0deg)}
      50%{transform:rotate(180deg)}
      100%{transform:rotate(360deg)}
    }
  }
</style>
